// Local-calendar date helpers for the availability window.
//
// Availability is a wall-clock, Europe/Dublin concept: a pharmacy's "Monday
// 09:00" is 09:00 on the shop floor whatever the UTC offset happens to be
// that week. `Date#toISOString()` formats in UTC, so building the window with
// it silently shifted every request made during Irish Summer Time (UTC+1)
// between 00:00 and 00:59 local:
//
//   * the patient's own day dropped out of the window (it formatted as
//     yesterday), and
//   * the day either side of a clocks-change formatted twice, so one calendar
//     day was requested twice and the last day of the window never at all.
//
// Both symptoms read to the patient as "that date isn't bookable" against a
// pharmacist's live schedule. Everything here therefore works from local
// calendar fields only, and day arithmetic goes through the Date constructor's
// own normalisation rather than adding 24h of milliseconds — a 23- or 25-hour
// day must still advance the calendar by exactly one.

/** Formats a `Date` as `YYYY-MM-DD` in the local calendar, never in UTC. */
export function toLocalIsoDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/**
 * The next `dayCount` local calendar days starting with `from`'s own day,
 * as `YYYY-MM-DD` strings — consecutive, unique, and unaffected by a
 * daylight-saving transition inside the window.
 */
export function localDateWindow(dayCount: number, from: Date = new Date()): string[] {
  const days: string[] = [];
  for (let i = 0; i < dayCount; i++) {
    days.push(toLocalIsoDate(new Date(from.getFullYear(), from.getMonth(), from.getDate() + i)));
  }
  return days;
}
